<template>
    <div>
        <div class="mb-3" v-if="$route.params.id">
            <a href="#" @click.prevent="closeReplies()">
                <h4>
                    <i class="fas fa-arrow-left"></i>
                    戻る
                </h4>
            </a>
        </div>
        <div class="news my-2" ref="news">
            <div class="card-body">
                <div class="mb-3" v-if="fixed">
                    <i class="fas fa-thumbtack"></i> 固定
                </div>
                <button type="button" class="close" @click="remove(news)">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div v-if="news.review_id" class="review">
                    <div class="badge bagde-pills badge-info" v-if="news.review.applause">
                        <h6 class="m-0">{{news.review.applause.caption}}</h6>
                    </div>
                    <div v-html="$filters.wrap(news.review.body)"></div>
                    <div v-if="news.review.book" class="small text-right">
                        ――{{news.review.book.title}}
                        <span v-if="news.review.section">「{{news.review.section.section_name}}」</span>
                    </div>
                    <hr>
                    <h6>返信</h6>
                    <div v-html="$filters.wrap(news.review.reply)"></div>
                </div>
                <div class="card-text" v-else v-html="$filters.url(news.body, true)"></div>
                <div v-if="news.image" class="d-flex justify-content-center">
                    <img :src="news.image" class="img-fluid img-news">
                </div>
                <div v-else-if="getUrl(news.body)" class="my-3">
                    <ogp-pane :url="getUrl(news.body)"></ogp-pane>
                </div>
                <div class="text-muted small d-flex justify-content-end mt-2">
                    <ul class="horizontal-list">
                        <li class="pointer" @click="fixNews(news)">
                            <i class="fas fa-thumbtack"></i>
                        </li>
                        <li>
                            <a href="#" @click.prevent="closeReplies()" v-if="$route.params.id">
                                <i class="fas fa-comment-slash"></i>
                                返信
                                <span class="badge badge-pill badge-primary" v-if="replies.length">{{ replies.length }}</span>
                            </a>
                            <a href="#" @click.prevent="openReplies()" v-else>
                                <i class="far fa-comment"></i>
                                返信
                                <span class="badge badge-pill badge-primary" v-if="news.replies_count">{{ news.replies_count }}</span>
                            </a>
                        </li>
                        <li class="text-danger">
                            <heart :likes="news.likes" :disabled="true"></heart>
                            <span v-if="news.likes">
                                {{ news.likes }}
                            </span>
                        </li>
                        <li v-if="news.rating_id">
                            <div class="badge" :class="[ratingBadge(news.rating_id)]">
                                {{getRating(news.rating_id)}}
                            </div>
                        </li>
                        <li v-if="news.body.match(/^data:image/)">{{$filters.getSize(news.body)}}</li>
                        <li v-else>{{news.body.length}} 文字</li>
                        <li>{{$filters.dateFormat(news.created_at, 'YYYY-MM-DD HH:mm')}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <transition mode="out-in">
            <div v-if="$route.params.id" class="mt-2 mb-5">
                <div class="reply" v-for="r in replies">
                    <button type="button" class="close" @click="removeReply(r)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div :class="{'not-allowed': !r.is_allowed}" v-html="$filters.url(r.body)"></div>
                    <div v-if="r.image" class="d-flex justify-content-center">
                        <img :src="r.image" class="img-fluid img-news">
                    </div>
                    <div v-else-if="getUrl(r.body)" class="my-3">
                        <ogp-pane :url="getUrl(r.body)"></ogp-pane>
                    </div>
                    <div class="text-muted reply-footer d-flex justify-content-between mt-2">
                        <div class="d-flex justify-content-start" v-if="!r.is_allowed">
                            <div class="mr-3">
                                <span class="badge badge-danger">未承認</span>
                            </div>
                            <div class="mr-3">
                                <a href="#" @click.prevent="allowReply(r)">
                                    <i class="far fa-thumbs-up"></i>
                                    承認する
                                </a>
                            </div>
                        </div>
                        <div v-else></div>
                        <div class="d-flex justify-content-end">
                            <div class="pointer text-danger mr-2" @click="likeReply(r)">
                                <heart :likes="r.likes"></heart>
                                <span v-if="r.likes">
                                    {{ r.likes }}
                                </span>
                            </div>
                            <div class="mr-3">
                                {{ r.name }}
                            </div>
                            <div>
                                {{$filters.dateFormat(r.created_at , 'YYYY-MM-DD HH:mm')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reply-form" v-if="replies.length < $store.state.max_replies">
                    <div class="text-pane">
                        <div class="text-pane-dummy">{{reply.body + '\u200b'}}</div>
                        <textarea class="text-pane-editor"
                            maxlength="250"
                            v-model="reply.body"
                            @keydown.ctrl.enter="postReply()"
                            @keydown.meta.enter="postReply()"
                            placeholder="返信"></textarea>
                    </div>
                    <div class="d-flex justify-content-between post-button-pane">
                        <div class="mr-2">
                            <button class="btn btn-sm btn-success" @click="$refs.image.click()">
                                <i class="far fa-file-image"></i>
                                画像
                                <input type="file" ref="image" @change="imageSelected" accept="image/*" class="d-none" />
                            </button>
                        </div>
                        <div class="flex-fill mr-2">
                            <button class="btn btn-primary btn-sm btn-block mr-2" :disabled="!available" @click="postReply()">
                                投稿
                            </button>
                        </div>
                        <div class="length-graph">
                            <circle-graph :value="replyLength"></circle-graph>
                        </div>
                    </div>
                    <div v-if="image.url" class="position-relative mt-3">
                        <i class="far fa-times-circle remove-image" @click="removeImage()"></i>
                        <div class="d-flex justify-content-center">
                            <img :src="image.url" class="img-thumbnail img-fluid" />
                        </div>
                    </div>
                    <div v-else-if="getUrl(reply.body)" class="my-3">
                        <ogp-pane :url="getUrl(reply.body)"></ogp-pane>
                    </div>
                    <div class="small text-center mt-3">
                        {{ replies.length }} /
                        <span v-if="$store.state.max_replies">{{ $store.state.max_replies }}</span>
                        件
                    </div>
                </div>
                <div class="reply-form" v-else>
                    返信の最大数に達しました。
                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped>
.img-news {
    border-radius: 1rem;
    margin: 1rem 0;
}
.news {
    border: 1px solid #aaa;
    border-radius: .5rem;
}
.review {
    margin: 2rem 1rem 1rem;
    padding: 1rem;
    border-radius: .5rem;
    border: 1px solid #ddd;
}
.length-graph {
    width: 28px;
    height: 28px;
}
.reply {
    width: 100%;
    margin: 1.5rem 0 .5rem;
    padding: .9rem;
    font-size: .85rem;
    border: 0;
    border-radius: .4rem;
    background-color: rgba(255, 255, 255, .2);
    position: relative;
    overflow: visible;
    &:before {
        content: "";
        position: absolute;
        top: -30px;
        left: 50%;
        margin-left: -15px;
        border: 15px solid transparent;
        border-bottom: 15px solid rgba(255, 255, 255, .2);
    }
    .not-allowed {
        opacity: 0.5;
    }
    .reply-footer {
        font-size: 0.8rem;
    }
}
.remove-image {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 2rem;
    cursor: pointer;
    &:hover {
        opacity: .8;
    }
}
.reply-form {
    width: 100%;
    margin: 1.5rem 0 .5rem;
    padding: .9rem;
    font-size: .85rem;
    border: 0;
    border-radius: .4rem;
    background-color: rgba(127, 127, 127, .2);
    position: relative;
    overflow: visible;
    &:before {
        content: "";
        position: absolute;
        top: -30px;
        left: 50%;
        margin-left: -15px;
        border: 15px solid transparent;
        border-bottom: 15px solid rgba(127, 127, 127, .2);
    }
}
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    font-size: 0.85rem;
    line-height: 1.8rem;
    .text-pane-dummy {
        overflow: hidden;
        box-sizing: border-box;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
        padding: 0.375rem 0.8rem;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        padding: 0.375rem 0.8rem;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
.post-button-pane {
    height: 2rem;
}
</style>

<script>
import ogpPane from "components/Ogp";
import circleGraph from "components/circleGraph";
import heart from "components/Heart";
export default {
    components: {
        ogpPane,
        circleGraph,
        heart,
    },
    props: {
        news: {
            required: true
        },
        fixed: {
            default: false,
        },
        ratings: {
            default: []
        },
    },
    data() {
        return {
            reply: {
                news_id: null,
                body: "",
            },
            image: {
                info: null,
                url: null,
            },
            isLoading: false,
            replies: [],
            scrollTop: null,
        }
    },
    methods: {
        getRating(rating_id) {
            const rate = _.find(this.ratings, {id: rating_id});
            if (rate) {
                return rate.rating_name;
            }
            return "なし";
        },
        ratingBadge(rating_id) {
            const rate = _.find(this.ratings, {id: rating_id});
            if (rate) {
                return "badge-" + rate.color;
            }
            return "badge-secondary";
        },
        getUrl(body) {
            const matches = body.match(/(https?:\/\/[\w!?\/+\-_~;.,*&@#$%()'[\]]+)/g);
            if (matches) {
                return matches.pop();
            }
            return null;
        },
        fixNews(n) {
            let action = "固定";
            if (this.fixed) {
                action = "固定を解除";
            }
            Swal.fire({
                title: action,
                text: `指定の一言を${action}します。よろしいですか？`,
                icon: "info",
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonText: action,
                cancelButtonText: "キャンセル",
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/news/toggle-fix", {id: n.id}).then(res => {
                        alert.msg("一言を固定化しました");
                    }).catch(err => { alert.err(err) });
                }
            });
        },
        remove(n) {
            let text = "指定の一言を削除します。よろしいですか？";
            if (n.review_id) {
                text = "感想の返信を削除します。感想の返信を削除しても、感想自体は削除されず、一言欄の表示が消えるだけです。よろしいですか？";
            }
            Swal.fire({
                title: "一言削除",
                text: text,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/news/remove", {'id': n.id}).then(res => {
                        alert.msg(res.data);
                        if (this.$route.params.id) {
                            this.closeReplies();
                        }
                    }).catch(err => {
                        alert.err(err);
                    });
                }
            });
        },
        async load() {
            const loader = await this.__load();
            this.replies = loader.data;
        },
        __load() {
            return axios.get("/mypage/news/replies", {params: {id: this.news.id}});
        },
        async openReplies() {
            const loader = await this.__load();
            this.replies = loader.data;
            this.connectChannel();
            this.scrollTop = document.documentElement.scrollTop;
            this.$router.push(`/mypage/news/${this.news.id}`);
            setTimeout(() => {
                this.$emit("opened", this.news.id);
                const offsetTop = this.$refs.news.getBoundingClientRect().top + window.scrollY - 100;
                setTimeout(() => {
                    $("html,body").animate({scrollTop: offsetTop}, 300);
                });
            });
        },
        closeReplies() {
            this.leaveChannel();
            setTimeout(() => {
                this.$emit("closed");
                this.$router.push(`/mypage/news`);
                setTimeout(() => {this.$emit("load", this.scrollTop)});
            });
        },
        allowReply(r) {
            axios.post("/mypage/news/reply/allow", {id: r.id}).then(res => {
            }).catch(err => { alert.err(err) });
        },
        removeReply(r) {
            Swal.fire({
                title: "返信削除",
                text: "指定の返信を削除します。よろしいですか？",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/news/reply/remove", {'id': r.id}).then(res => {
                        alert.msg(res.data);
                    }).catch(err => {
                        alert.err(err.response);
                    });
                }
            });
        },
        postReply() {
            if (this.isLoading) return;
            this.isLoading = true;
            const fd = new FormData();
            fd.append('image', this.image.info);
            fd.append('image_url', this.image.url);
            fd.append('body', this.reply.body);
            fd.append('news_id', this.news.id);
            axios.post("/mypage/news/reply/save", fd).then(res => {
                alert.msg(res.data);
                this.reply = {
                    news_id: this.news.id,
                    body: "",
                };
                this.image = {
                    info: null,
                    url: null,
                };
                this.isLoading = false;
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        },
        removeImage() {
            this.image.info = null
            this.image.url = "";
        },
        imageSelected() {
            if (this.$refs.image.files[0].size > 1024 * 1024 * 5) {
                alert.err("ファイルサイズが大きすぎます: " + this.$filters.getByte(this.$refs.image.files[0].size));
                return;
            }
            this.image.info = this.$refs.image.files[0];
            this.image.url = URL.createObjectURL(this.image.info);
        },
        likeReply(r) {
            if (r.user_id == this.$store.state.user.id) {
                return;
            }
            axios.post("/mypage/news/reply/like", {id: r.id}).then(res => {
            }).catch(err => { alert.err(err) });
        },
        connectChannel() {
            if (Echo.connector.channels["news." + this.news.id]) {
                this.leaveChannel();
                this.connectChannel();
                return;
            }
            Echo.channel("news." + this.news.id).listen("News\\ReplyUpdate", (e) => {
                if (this.news.id == e.news_id) {
                    this.load();
                }
            });
        },
        leaveChannel() {
            if (!Echo.connector.channels["news." + this.news.id]) return;
            Echo.leaveChannel("news." + this.news.id);
        },
    },
    computed: {
        available() {
            if (this.reply.body && !this.isLoading) {
                 return true;
            }
            return false;
        },
        replyLength() {
            return this.reply.body.length / 250 * 100;
        },
    },
    mounted() {
        if (this.$route.params.id) {
            this.openReplies();
        }
    },
    unmounted() {
        this.leaveChannel();
    }
}
</script>